import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from './Content';

const styles = () => ({
  root: {},
});

const ModuleWelcomeStepTemplate = ({
  className,
  classes,
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      resource={resource}
      layout={Content}
      headerTransparentBackground
      primaryActionLabel={'Get Started'}
    />
  );
};

ModuleWelcomeStepTemplate.defaultProps = {
  className: '',
};

ModuleWelcomeStepTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(ModuleWelcomeStepTemplate);
